<template>
  <div class="shotList">
    <SearchBar ref='searchBar' :mallGroupId="GroupId" :selectedRows='selectedRows' @searchOrderList='searchOrderList' />
    <a-row justify='space-between'>
      <a-space>
        <a-tag style="font-size: 14px" color='blue'>
          共查询到{{ total }}条 / 当前页{{ shotOrderList.length }}条 / 已勾选{{ selectedRowKeys.length }}条
        </a-tag>
      </a-space>
      <a-pagination
        size="small"
        class="myPagination"
        show-quick-jumper
        v-model:current="currentPage"
        v-model:pageSize="pageSize"
        :show-total="total => `共 ${total} 个订单`"
        :total="total"
        :disabled="loading"
        @change="changePage"
      />
    </a-row>
    <a-table
      class="mytable"
      :columns="columns"
      :data-source="shotOrderList"
      :loading="{ spinning: loading, tip: '正在加载订单数据中', size: 'large' }"
      :pagination="false"
      tableLayout="fixed"
      :row-selection="rowSelection"
      :row-key="(record) => record.orderId + ''"
      :scroll="{ y: 'calc(100vh - 210px)' }"
      bordered
    >
      <!-- 订单信息 -->
      <template #orderInfo="{ record }">
        <div class="font_12">
          <p>店铺名称: <span>{{ record.mallName }}</span></p>
          <p>订单编号: <span>{{ record.orderId }}</span> <CopyOutlined class="color_skyBlue commonCopyItem" :data-clipboard-text="record.orderId" /></p>
          <p>商品编号: <span>{{ record.goodsId }}</span> <CopyOutlined class="color_skyBlue commonCopyItem" :data-clipboard-text="record.goodsId" /></p>
          <p>订单状态: <a-tag style="font-size: 14px" color="blue">{{ record.orderStatus }}</a-tag></p>
          <p>售后状态: <a-tag style="font-size: 14px" color="blue">{{ record.afterStatus }}</a-tag></p>
          <p>商品数量: <span>{{ record.goodsCount }}</span></p>
        </div>
      </template>
      <!-- 商品名称 -->
      <template #goodsInfo="{ record }">
        <a-space>
          <TableImgVue :src="record.goodsImg" />
          <span>{{ record.goodsTitle }}</span>
        </a-space>
      </template>
      <!-- 订单金额 -->
      <template #orderPrice="{ record }">
        <div class="font_12" style="text-align: left;margin-left: 2em">
          <p>商品总额: <span>{{ record.goodsTotalPrice }}</span></p>
          <p v-if="false">平台补贴: <span>{{ record.platformCostAmount }}</span></p>
          <p>实付金额: <span>{{ record.payAmount }}</span></p>
          <p>拍单金额: <span>{{ record.cost }}</span></p>
          <p>订单利润: <span>{{ record.profit }}</span></p>
        </div>
      </template>
      <!--拍单订单号  -->
      <template #purchasedOrderId="{ record }">
        {{ record.purchasedOrderId }} <CopyOutlined class="color_skyBlue commonCopyItem" :data-clipboard-text="record.purchasedOrderId" />
        <div>
          <a-button size="small" type="primary" ghost @click="openCaigouDetail(record)">采购详情</a-button>
        </div>
      </template>
      <!-- 拍单账号 -->
      <template #purchasedAccount="{ record }">
        <a-tag color='blue' style="font-size: 14px;padding: 2px 3px;margin-right:2px">
          <img style="width:20px;height:20px;margin-right: 3px;border-radius: 3px" :src="record.itemType.img" alt="">
          <span style="vertical-align:middle;">{{ record.itemType.name }}</span>
        </a-tag>
        {{ record.purchasedAccount }} 
      </template>
      <!--订单时间 -->
      <template #OrderTime="{ record }">
        <div class="font_12">
          <p>下单时间: <span>{{ record.orderCreateTime }}</span></p>
          <p>拍单时间: <span>{{ record.purchasedTime }}</span></p>
        </div>
      </template>
    </a-table>
    <a-back-top title="点我回到顶部" style="right: 50px; bottom: 60px" :target="backTopTarget" />
  </div>
</template>
<script>
import handler from './handler'
import tableInfo from './table_info'
import Tablehandler from '@/utils/base/table_handler'
import TableImgVue from '@/views/base/components/TableImg.vue'
import { CopyOutlined } from '@ant-design/icons-vue'
import SearchBar from './components/search_bar'
import { ResertCopy } from '@/utils/view_util'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      total: 0,
      shotOrderList: [],
      columns: tableInfo.columns,
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      formState: {},
      currentPage: 1,
      pageSize: 100
    }
  },
  computed: {
    rowSelection() {
      return Tablehandler.rowSelection(this, 'orderId')
    },
    ...mapGetters({
      // mallList: 'mall_group/mallList',
      GroupId: 'mall_group/GroupId' // 店群ID
    })
  },
  components: { TableImgVue, CopyOutlined, SearchBar },
  methods:{
    // 获取拍单列表
    async getOrderList() {
      this.loading = true
      const { total, errMsg, shotOrderList } = await handler.GetOrderList(
        this.GroupId,
        this.currentPage,
        this.pageSize,
        this.formState
      )
      if (errMsg) this.$message.warn(`获取拍单数据失败，原因:【${errMsg}】`)
      else if (!errMsg && !shotOrderList.length) this.$message.info('暂无拍单记录')
      this.total = total
      this.shotOrderList = shotOrderList
      this.loading = false
    },
    searchOrderList(formState) {
      this.formState = formState
      this.currentPage = 1
      this.getOrderList()
    },
    changePage(currentPage) {
      this.currentPage = currentPage
      this.getOrderList()
    },
    // 打开1688采购详情
    openCaigouDetail(orderInfo) {
      open(`https://trade.1688.com/order/new_step_order_detail.htm?orderId=${orderInfo.purchasedOrderId}`)
    },
    backTopTarget() {
      return document.querySelector('.ant-table-body')
    }
  },
  mounted() {
    ResertCopy()
  }
}
</script>
<style lang='less' scoped>
  @import './index';
</style>